export default "__VITE_ASSET__BT3CV$0A__"